import type { EndpointConfig } from './endpoints';

function getCSRFToken() {
  const name = 'csrftoken2';
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(name + '=')) {
      return decodeURIComponent(trimmed.substring(name.length + 1));
    }
  }
  return null;
}

async function getCaptchaToken() {
  // Skip captcha in development (port 3000)
  if (window.location.port === '3000') {
    console.log('Skipping reCAPTCHA in development');
    return null;
  }
  
  return new Promise((resolve) => {
    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.enterprise.ready(async () => {
        const token = await grecaptcha.enterprise.execute('6LcEscIUAAAAABSW3cxkOzgX1ElaGSEDMvn4aiYv', { action: 'LOGIN' });
        resolve(token);
      });
    } else {
      resolve(null);
    }
  });
}

export class ApiClient {
  private baseHeaders: HeadersInit = {
    'Content-Type': 'application/json; charset=utf-8',
    'X-Requested-With': 'XMLHttpRequest',
  };

  async request<T>(
    config: EndpointConfig | string,
    params?: Record<string, any>,
    body?: any
  ): Promise<T> {
    const endpoint = typeof config === 'string' ? { url: config, method: 'POST' as const } : config;
    
    let url = endpoint.url;
    
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        url = url.replace(`:${key}`, String(value));
      });
    }

    const headers: HeadersInit = {
      ...this.baseHeaders,
      'X-CSRFToken': getCSRFToken() || '',
    };

    // Add reCAPTCHA token for login endpoint
    // if (url.includes('/sessions/validate/login/')) {
    //   const captchaToken = await getCaptchaToken();
    //   if (captchaToken) {
    //     headers['g-recaptcha-response'] = captchaToken;
    //   }
    // }

    const options: RequestInit = {
      method: endpoint.method,
      credentials: 'include',
      cache: 'no-cache',
      redirect: 'follow',
      headers,
    };

    if (body && ['POST', 'PUT', 'PATCH'].includes(endpoint.method)) {
      options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }

    return await response.json();
  }
}

export const apiClient = new ApiClient();
